var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomline2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 12,
    viewBox: "0 0 154 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.0382C21.5286 7.0382 41.0572 7.0382 60.5859 7.0382C62.0347 7.0382 62.1677 6.99681 62.1399 7.7698C62.1143 8.47715 61.7902 9.16318 61.7902 9.87315C61.7902 10.1502 62.0785 9.90674 62.2953 9.77154C63.9065 8.76665 65.6722 7.87832 67.6177 7.04836C72.2483 5.07294 77.4445 3.33761 83.1966 2.41489C84.9138 2.13941 87.9067 1.81361 89.7234 2.13037C91.391 2.42115 90.4615 6.44034 90.4615 7.34303C90.4615 7.61371 90.1208 8.83435 90.5392 9.00946C90.8717 9.14858 98.4084 6.33892 98.9697 6.16434C103.37 4.79567 118.86 0.101152 119.657 5.52419C119.825 6.66309 119.832 7.79733 119.832 8.93833C119.832 10.0866 128.508 7.35342 128.787 7.28206C135.104 5.66476 140.858 4.43191 147.901 4.30485C149.287 4.27985 150.679 4.24725 152 4.47759",
    stroke: "#8A2BE2",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.0382C8.2508 7.0382 61.8157 6.34101 61.7902 7.04836C61.7647 7.75571 61.7902 9.16318 61.7902 9.87315C61.7902 10.1502 62.0785 9.90674 62.2953 9.77154C63.9065 8.76665 65.6722 7.87832 67.6177 7.04836C72.2483 5.07294 77.4445 3.33761 83.1966 2.41489C84.9138 2.13941 87.9067 1.81361 89.7234 2.13037C91.391 2.42115 90.4615 6.44034 90.4615 7.34303C90.4615 7.61371 90.1208 8.83435 90.5392 9.00946C90.8717 9.14858 98.4084 6.33892 98.9697 6.16434C103.37 4.79567 118.86 0.101152 119.657 5.52419C119.825 6.66309 119.832 7.79733 119.832 8.93833C119.832 10.0866 128.508 7.35342 128.787 7.28206C135.104 5.66476 140.858 4.43191 147.901 4.30485C149.287 4.27985 150.679 4.24725 152 4.47759",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomline2);
export default __webpack_public_path__ + "static/media/bottomline2.ed9c167deace3ad1afb94e24de69fc03.svg";
export { ForwardRef as ReactComponent };